/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from '@insticator/insticator-ui';



/* ++++++++++ --------------- MONETIZATION - CONFIGURATION PAGE : STYLES --------------- ++++++++++ */
export default {
    configuration: {
    }
};
